import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app/App";
import "./custom.css";
import "./assests/styles/comun.scss";
import "./assests/styles/main.scss";
import "./assests/styles/buttons.scss";
import "primeicons/primeicons.css";
import "./assests/styles/dataTable.scss";

import * as serviceWorker from "./registerServiceWorker";




// Gestión de versión y persistencia directamente en index.js
const APP_VERSION = window.APP_VERSION || "dev";
const STORED_VERSION = localStorage.getItem('app_version');
const RELOAD_MARK = 'version_reload';
console.log("Versión de la app:", APP_VERSION);
console.log("Versión guardada en localStorage:", STORED_VERSION);

if (sessionStorage.getItem(RELOAD_MARK)) {
	// Tras la recarga: actualiza la versión y elimina la marca
	localStorage.setItem('app_version', APP_VERSION);
	sessionStorage.removeItem(RELOAD_MARK);
	console.log('[APP] Recarga completada, versión actualizada en localStorage.');
} else if (STORED_VERSION && STORED_VERSION !== APP_VERSION) {
	// Si la versión cambió, recarga la página forzando actualización total (sin caché)
	sessionStorage.setItem(RELOAD_MARK, '1');
	console.log(`[APP] Versión cambiada (${STORED_VERSION} → ${APP_VERSION}). Forzando recarga total.`);
	var url = window.location.href.split('#')[0];
	var sep = url.includes('?') ? '&' : '?';
	window.location.replace(url + sep + 'v=' + APP_VERSION);
} else if (!STORED_VERSION) {
	// Primera carga: guarda la versión
	localStorage.setItem('app_version', APP_VERSION);
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
